<div class="polaris-progress">
  <div class="polaris-progress__fill" [style.width.%]="progress"></div>
</div>
